<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { pathToCart, openBuyAnother, useCart, useOrderStore } from '@consumer/services/order'
import { checkout, giftIdeaLanding } from '@consumer/api'
import { faCopy, faPen, faTrash } from '@fortawesome/pro-light-svg-icons'
import { useScreen } from '@consumer/helpers/screen'

import OrderSummaryOrderItemPreview from '@consumer/modules/checkout/OrderSummaryOrderItemPreview.vue'
import OrderGiftContent from '@consumer/modules/checkoutCart/OrderGiftContent.vue'
import checkoutCartEmptyImage from '@consumer/assets/images/checkout-cart-empty.jpg'
import { openGiftWizard } from '@consumer/services/modals'

const cart = useCart()
const orderStore = useOrderStore()

const __$temp_1 = (useScreen()),
  isDesktop = _toRef(__$temp_1, 'isDesktop');
</script>

<template>
  <div
    class="flex flex-col gap-4"
    :style="isDesktop && { minWidth: cart.isEmpty ? '300px' : '400px', maxWidth: '500px' }"
  >
    <GLink
      v-if="cart.isEmpty"
      :href="giftIdeaLanding.buyAGift.path()"
      name="cart-menu-start-gifting"
      class="pt-2 lg:pt-4"
    >
      <img :src="checkoutCartEmptyImage" alt="Your cart is empty" class="mx-auto" width="220" height="160">
    </GLink>
    <div v-else>
      <GLink
        v-for="(orderGift, index) in cart.recentlyAddedGifts"
        :key="orderGift.id"
        class="flex items-center gap-3 py-4"
        :class="index > 0 && 'border-t border-grey-primary'"
        :href="pathToCart(orderGift)"
      >
        <OrderSummaryOrderItemPreview
          :orderGift="orderGift"
          :style="{ width: isDesktop ? '140px' : '100px' }"
          :class="[
            isDesktop && '-mb-2',
            !orderGift.greeting.to && '-mt-6',
          ]"
          class="flex-shrink-0"
        />
        <OrderGiftContent
          :orderGift="orderGift"
          compact
          class="text-v2-secondary flex-1"
          style="min-width: 150px;"
        >
          <div class="mt-1 flex items-center w-full gap-2">
            <div class="flex items-center gap-2">
              <GPromiseButton
                flat
                :icon="faPen"
                label="Edit"
                @click.prevent.stop="openGiftWizard({ orderGift, origin: 'menu' })"
              />
              <span class="text-v2-tertiary">&bull;</span>
              <GPromiseButton
                flat
                :icon="faCopy"
                label="Buy Another"
                @click.prevent.stop="openBuyAnother({ orderGift, origin: 'menu' })"
              />
            </div>
            <GPromiseButton
              flat
              danger
              :icon="faTrash"
              class="ml-auto"
              @click.prevent.stop="orderStore.removeOrderGift(orderGift)"
            />
          </div>
        </OrderGiftContent>
      </GLink>
    </div>

    <GButton
      v-if="cart.isEmpty"
      variant="primary"
      class="w-full whitespace-nowrap"
      label="Start Gifting"
      :href="giftIdeaLanding.buyAGift.path()"
      name="cart-menu-start-gifting"
    />
    <template v-else>
      <GButton
        variant="secondary"
        class="w-full whitespace-nowrap"
        :label="
          cart.count > cart.recentlyAddedGifts.length
            ? `View Cart (${cart.count})`
            : 'View Cart'
        "
        :href="checkout.cart.path()"
        name="cart-menu-view-cart"
      />
      <GButton
        variant="primary"
        class="w-full !lg:hidden whitespace-nowrap"
        label="Proceed to Checkout"
        :href="checkout.checkout.path()"
        name="cart-menu-proceed-to-checkout"
        data-track-ga="cart-proceed-to-checkout"
      />
    </template>
  </div>
</template>
